export default {
  all: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/productRecommendation/state.js